<template>
    <div class="products-detail">
        <top-cards
            :hide-contacts="!(data.contacts && data.contacts.items && data.contacts.items.length)"
            class="u-bottom-margin--xl"
        />

        <products-detail-content
            v-if="data.text"
            :data="data.text"
            class="u-top-margin--xs"
        />

        <products-detail-content
            v-if="data.detail"
            :data="data.detail"
            class="u-top-margin--xs"
        />

        <z-accordion
            initial="first"
            class="u-top-margin--l"
            v-if="data.accordions && data.accordions.length"
        >
            <z-accordion-item
                :key="index"
                :id="`${index + 1}`"
                v-for="(item, index) in data.accordions"
            >
                <template v-slot:header>
                    <span>{{ item.name }}</span>
                </template>
                <template v-slot:body>
                    <products-detail-content :data="item.detail" />
                </template>
            </z-accordion-item>
        </z-accordion>

        <!-- <h2
            class="u-bottom-margin--s"
            v-if="data.certificates && data.certificates.length"
        >{{ text.certificates }}</h2>

        <z-table
            fixed
            :columns="text.columns"
            v-if="data.certificates && data.certificates.length"
        >
            <z-table-row
                :key="index"
                v-for="(row, index) in data.certificates"
            >
                <z-table-col index="0">
                    <z-link
                        :href="row.link"
                        target="_blank"
                    >
                        <span v-html="row.name"></span>
                    </z-link>
                </z-table-col>
                <z-table-col index="1">
                    <span v-html="row.number"></span>
                </z-table-col>
                <z-table-col index="2">
                    <span v-html="row.body"></span>
                </z-table-col>
            </z-table-row>
        </z-table> -->

        <contacts-page is-product class="u-top-margin--xl"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Contacts from './Contacts.vue'
import TopCards from './TopCards.vue'
import ProductsDetailContent from './ProductsDetailContent.vue'

export default {
    name: 'products-detail',
    props: {
        hidePrices: {
            type: Boolean,
            default: false
        },
        hideCertificates: {
            type: Boolean,
            default: false
        }
    },
    components: {
        TopCards,
        Contacts,
        ProductsDetailContent
    },
    data () {
        return {
            text: {
                certificates: this.$root.lang === 'ru' ? 'Сертификаты' : 'Certificates',
                columns: [
                    this.$root.lang === 'ru' ? 'Название' : 'Name',
                    this.$root.lang === 'ru' ? 'Номер сертификата' : 'Certificate number',
                    this.$root.lang === 'ru' ? 'Наименование органа по сертификации' : 'Certification body name'
                ]
            }
        }
    },
    computed: {
        data () {
            return this.$root.app.components['products-detail'] ? this.$root.app.components['products-detail'] : {}
        },
        isContactsShown () {
            return Boolean(this.data && this.data.contacts && this.data.contacts.items.length)
        }
    },
    methods: {
        ...mapActions(['SetHeroTitle'])
    },
    created () {
        // if (this.data.title) this.SetHeroTitle(this.data.title)
    }
}
</script>
